import { render, staticRenderFns } from "./ReturnsBoardClassCard.vue?vue&type=template&id=6b6f225e&"
import script from "./ReturnsBoardClassCard.vue?vue&type=script&lang=js&"
export * from "./ReturnsBoardClassCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports